import React from 'react';
import {
  Row, Col, Badge,
} from 'react-bootstrap';
import img from 'assets/img/oportunidadPlaceholder990px.jpg';
import { ReactComponent as IconPin } from 'assets/icons/pin.svg';
import { PromotionDetail } from 'types/FutureInvestment';

function PromotionOverview( { promotion }:{ promotion: PromotionDetail | null } ) {
  const imageSrc = promotion?.bigImageUrl?.trim() ? promotion.bigImageUrl : img;
  return (
    <div className="bg-image">
      <img src={imageSrc} alt="Oportunidades" />

      <div className="bg-image-content">
        <Row>
          <Col className="text-end">
            <Badge bg="outline-gray16" text="gray16">
              {promotion?.estadoVentas}
            </Badge>
          </Col>
        </Row>

        {/* <Badge bg="outline-white" text="white">
          <IconBell />
          <span className="ms-2">Plazo: Jun 2025</span>
        </Badge> */}

        <h1 className="title">
          {promotion?.provincia && (
          <>
            {promotion.provincia}
            {' '}
            |
            {' '}
          </>
          )}
          {promotion?.codigoPromocion}
        </h1>
        <h5 className="subtitle">
          {promotion?.tipoActivo}
          {( promotion?.tipoActivo || promotion?.direccion ) && (
          <IconPin className="mx-2" />
          )}
          {promotion?.direccion}
        </h5>

        {/* <Button variant="icon-orange">
          <span className="btn-icon-rounded">
            <IconCheck height={20} />
          </span>
          Me interesa
        </Button> */}
      </div>
    </div>

  );
}

export default PromotionOverview;
